import { isB2bStaff, managerUserAclGroups } from 'helpers/user';
import {
  BUSINESS_ADMIN,
  MANAGER,
  RESELLER,
  RESELLER_ADMIN,
  RESELLER_AGENT,
  RESELLER_GROUP,
} from './userGroups';

/**
 * Resellers only allowed to restore or suspend subs, that were created by them
 */
export function attRestoreSuspendResellerRule(
  userGroup,
  { sub, loggedInUser },
) {
  if (userGroup !== RESELLER) return true;
  if (!sub || !loggedInUser) return false;
  return sub.created_by === loggedInUser.id;
}

/**
 * Business child can edit only own profile
 */
export function editProfileBusinessChildRule(
  userGroup,
  { user, loggedInUser },
) {
  if (userGroup !== BUSINESS_ADMIN) return true;
  if (!user || !loggedInUser) return false;

  return user.id === loggedInUser.id;
}

/**
 * Business child can edit only own profile
 */
export function editProfileResellerGroupRule(
  userGroup,
  { user, loggedInUser },
) {
  if (!RESELLER_GROUP.includes(userGroup)) return true;
  if (!user) return false;

  switch (userGroup) {
    case RESELLER_ADMIN:
    case RESELLER_AGENT: {
      return loggedInUser.parent !== user.id;
    }
    default:
      return true;
  }
}

/**
 * Reseller group can edit only child users email
 */
export function resellersEditUserEmailRule(userGroup, { user }) {
  if (!RESELLER_GROUP.includes(userGroup)) return true;
  if (!user) return false;

  return !RESELLER_GROUP.includes(user.acl_group_name);
}

/**
 * Any user can't change b2b staff user group
 * Reseller group can edit only child user group
 * Manager can edit only users from manager available user group list
 */
export function editUserGroupRule(userGroup, { user }) {
  if (!user) return false;

  if (isB2bStaff(user)) {
    return false;
  }

  if (!RESELLER_GROUP.includes(userGroup) && userGroup !== MANAGER) return true;

  switch (userGroup) {
    case RESELLER:
    case RESELLER_ADMIN:
    case RESELLER_AGENT: {
      return !RESELLER_GROUP.includes(user.acl_group_name);
    }
    case MANAGER:
      return managerUserAclGroups.includes(user.acl_group_name);
    default:
      return false;
  }
}

/**
 * Business admin can't create owner address
 * Reseller admin can't create owner address
 */
export function createAddressRule(userGroup, { loggedInUser, userId }) {
  if (userGroup !== RESELLER_ADMIN && userGroup !== BUSINESS_ADMIN) return true;
  if (!loggedInUser || !userId) return false;

  return loggedInUser.parent !== userId;
}

/**
 * Business admin group can't edit owner address
 * Reseller group admin group can edit onbly own address
 */
export function editAddressRule(userGroup, { loggedInUser, userId }) {
  const isResellerGroup = RESELLER_GROUP.includes(userGroup);

  if (!isResellerGroup && userGroup !== BUSINESS_ADMIN) return true;
  if (!loggedInUser || !userId) return false;

  return Number(userId) === loggedInUser.id;
}

/**
 * Can't deactivate own account
 * Reseller admin can't deactivate parent account
 */
export function deactivateUserRule(userGroup, { loggedInUser, userId }) {
  if (!loggedInUser || !userId) return false;
  userId = Number(userId);

  if (userGroup === RESELLER_ADMIN) {
    if (loggedInUser.parent === userId) {
      return false;
    }
  }

  return userId !== loggedInUser.id;
}
